import React, { useEffect, useState } from 'react';
import { BrandOption, MealType, MealsResponse } from 'utils/types';
import { apiService } from 'services/base.service';
import Select from 'components/base/select';

type Props = {
  selectedMeal: BrandOption[];
  selectedBrand: BrandOption[];
  setSelectedMeal: (e: BrandOption[]) => void;
  hasSearch?: boolean;
  multiple?: boolean;
  multipleBrands?: boolean;
};

const SelectMeal = ({
  selectedMeal = [],
  setSelectedMeal,
  selectedBrand,
  multiple,
  hasSearch,
  multipleBrands
}: Props) => {
  const [loading, setLoading] = useState(false);
  const [mealsList, setMealsList] = useState<BrandOption[]>([]);

  const getMealsByBrand = async () => {
    if (!selectedBrand?.length) return;
    const brand_id = selectedBrand[0].value;
    try {
      setLoading(true);
      const res: MealsResponse = await apiService.get(
        `internal/brand/meals/${brand_id}?image=true`,
        {
          isInternal: true
        }
      );
      const { meals } = res.data;

      const mealsArray = meals?.map((meal: MealType) => {
        return {
          value: meal.id,
          text: meal.name,
          images: meal.images,
          selected: false
        };
      });
      setMealsList(mealsArray);
    } finally {
      setLoading(false);
    }
  };

  const getMealsByMultipleBrands = async () => {
    if (!selectedBrand?.length) return;
    try {
      setLoading(true);
      const res = await apiService.post(`marketing/meals-multiple-brand_id`, {
        data: {
          brand_ids: selectedBrand.map((brand) => brand.value)
        }
      });
      const { data } = res.data;

      const mealsArray = data?.map((meal: MealType) => {
        return {
          value: meal.id,
          text: multipleBrands ? meal?.brand?.name + ' - ' + meal.name : meal.name,
          images: meal.images,
          selected: false
        };
      });
      setMealsList(mealsArray);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedBrand) {
      if (multipleBrands) {
        getMealsByMultipleBrands();
      } else {
        getMealsByBrand();
      }
    }
  }, [selectedBrand]);

  if (multiple)
    return (
      <Select
        multiple
        hasSearch={hasSearch}
        loading={loading}
        values={selectedMeal.map((m) => m.value)}
        options={mealsList}
        placeholder='Select meal(s)'
        onChange={(v) => setSelectedMeal(mealsList.filter((m) => v.includes(m.value)))}
      />
    );

  return (
    <Select
      hasSearch={hasSearch}
      loading={loading}
      value={mealsList.map((m) => m.value)?.[0]}
      options={mealsList}
      placeholder='Select meal'
      onChange={(v) => setSelectedMeal(mealsList.filter((m) => m.value === v))}
    />
  );
};

export default SelectMeal;
